// Origin source from F1M2P5 Button Component,
// Remove ReactSVG because Central-Payment doesn't allow use it for multi-platform purpose

import React from 'react';
export default class Button extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.filterProps = {};
        Object.keys(this.props).forEach((v) => {
            if (!~['ghost', 'inline', 'radius', 'loading'].indexOf(v)) {
                this.filterProps[v] = this.props[v];
            }
        });
    }
    componentDidMount() {}
    render() {
        return (
            <button
                {...this.filterProps}
                onClick={this.props.onClick}
                disabled={this.props.disabled}
                className={`common-button ${this.props.ghost ? 'ghost' : ''} ${
                    this.props.radius ? 'radius' : ''
                } ${this.props.loading ? 'loading' : ''} ${
                    this.props.inline ? 'inline' : ''
                }${this.props.className ? ' ' + this.props.className : ''}`}
            >
                <span>{this.props.children}</span>
                {this.props.fufix ? this.props.fufix : null}
            </button>
        );
    }
}
